module.exports = __webpack_public_path__ + "img/van-der-mee.115ad60b.jpg";